import Joyride, { Callback } from 'react-joyride';

import { userActions } from '@store/user/user.slice';

import { useMutation } from '@hook/common/use-mutation.hook';
import { useUserGuide } from '@hook/user/use-user-guide.hook';
import { useSaveGuidesMutation } from '@hook/user/user.hooks';

import { locale, steps } from './consumer-guide.options';
import { consumerGuideStyle } from './consumer-guide.style';

export const ConsumerGuide = () => {
  const { completedConsumer } = useUserGuide();
  const { action: saveGuides } = useMutation(useSaveGuidesMutation(), userActions, userActions.setGuides);

  const run = !completedConsumer;

  const handleSaveGuides: Callback = ({ status }) => {
    if (status === 'skipped') {
      saveGuides({ completedCreateApplication: true, completedConsumer: true, completedDashboard: true });
    }
    if (status === 'finished') {
      saveGuides({ completedConsumer: true });
    }
  };

  if (completedConsumer) return null;

  return (
    <Joyride
      callback={handleSaveGuides}
      locale={locale}
      run={run}
      steps={steps}
      styles={consumerGuideStyle}
      continuous
      disableScrolling
    />
  );
};
